import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "utils/constants";
import { queryClient } from "utils/queryClient";

import { cancelSession } from "../services/Session.services";

export function useSession() {
  const navigate = useNavigate();

  const cancelSessionMutation = useMutation<void, Error, string>({
    mutationFn: (sessionId) => cancelSession(sessionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["sessions"] });
      navigate(ROUTES.HOME, {
        replace: true,
      });
    },
  });

  return { cancelSessionMutation };
}
